import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';

import formatPrice from 'utils/formatPrice';
import pxToEm from 'styles/pxToEm';
import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  label: {
    display: 'block',
    position: 'relative',
    marginBottom: 0,
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
  },
  typography: {
    display: 'block',
    padding: '4px 0',
    lineHeight: pxToEm(16, 14),
    minHeight: pxToEm(16, 14),
  },
});

const InventoryStockLineCreateEditUnitPriceFields = ({ variant, classes, ...fields }) => {
  const price = Number(get(fields, 'Price per Box').input.value.toString().replace(/[$,]/g, ''));
  const unitsInBox = get(fields, 'Units in Box').input.value;
  let pricePerUnit;

  if (variant === 'Kcal Units') {
    const kcalUnitsInItem = get(fields, 'Calories Per Unit').input.value;
    pricePerUnit = price && unitsInBox && kcalUnitsInItem
      ? ((price / unitsInBox) / kcalUnitsInItem) * 100 : null;
    if (pricePerUnit && Math.round(pricePerUnit) !== pricePerUnit) {
      pricePerUnit = pricePerUnit.toFixed(2);
    }
  } else {
    pricePerUnit = price && unitsInBox ? price / unitsInBox : null;
    if (pricePerUnit && Math.round(pricePerUnit) !== pricePerUnit) {
      pricePerUnit = pricePerUnit.toFixed(2);
    }
  }
  if (!pricePerUnit) {
    return '';
  }
  return (
    <Grid item>
      <InputLabel
        className={classes.label}
        disableAnimation
        shrink={false}
      >
        Cost per Unit:
      </InputLabel>
      <Typography className={classes.typography}>
        {pricePerUnit && formatPrice(pricePerUnit)}
      </Typography>
    </Grid>
  );
};

InventoryStockLineCreateEditUnitPriceFields.propTypes = {
  variant: PropTypes.oneOf(['Boxes', 'Kcal Units']),
  classes: PropTypes.shape({
    label: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryStockLineCreateEditUnitPriceFields.defaultProps = {
  variant: 'Boxes',
};

export default withStyles(styles)(InventoryStockLineCreateEditUnitPriceFields);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryStockLineCreateEditDialog/InventoryStockLineCreateEditUnitPriceFields.js